var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoColorMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 186,
    viewBox: "0 0 146 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.0873 152.66C43.7273 152.66 34.4436 150.373 26.2364 145.799C18.1636 141.224 11.7727 134.968 7.06364 127.03C2.35455 119.091 0 110.077 0 99.9859V3.92041H28.6582V79.8041L14.7327 82.2259C14.7327 76.0368 16.6164 70.2513 20.3836 64.8695C24.2855 59.4877 29.3309 55.1822 35.52 51.9531C41.7091 48.724 48.4364 47.1095 55.7018 47.1095C66.0618 47.1095 75.1436 49.3295 82.9473 53.7695C90.8855 58.2095 97.0745 64.4659 101.515 72.5386C105.955 80.4768 108.175 89.6259 108.175 99.9859C108.175 109.539 105.82 118.351 101.111 126.424C96.4018 134.362 89.9436 140.753 81.7364 145.597C73.6636 150.306 64.4473 152.66 54.0873 152.66ZM54.0873 125.617C59.0655 125.617 63.4382 124.473 67.2055 122.186C71.1073 119.764 74.1345 116.602 76.2873 112.7C78.44 108.799 79.5164 104.56 79.5164 99.9859C79.5164 95.2768 78.44 90.9713 76.2873 87.0695C74.1345 83.0331 71.1073 79.8713 67.2055 77.584C63.4382 75.2968 59.0655 74.1531 54.0873 74.1531C49.2436 74.1531 44.8709 75.2968 40.9691 77.584C37.2018 79.8713 34.1745 83.0331 31.8873 87.0695C29.7345 90.9713 28.6582 95.2768 28.6582 99.9859C28.6582 104.56 29.7345 108.799 31.8873 112.7C34.1745 116.602 37.2018 119.764 40.9691 122.186C44.8709 124.473 49.2436 125.617 54.0873 125.617Z",
    fill: "url(#paint0_linear_1_101)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.3562 171.759C100.231 171.543 131.687 139.097 131.687 99.1354C131.687 59.174 100.231 26.7281 61.3562 26.5115",
    stroke: "url(#paint1_linear_1_101)",
    strokeWidth: 20.0289,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_101",
    x1: 5.35124,
    y1: 0.764761,
    x2: -1.42467,
    y2: 140.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E24300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_101",
    x1: 61.3562,
    y1: 8.92883,
    x2: 32.1099,
    y2: 95.1876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E24300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7400"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84.0909,
    height: 171.24,
    fill: "white",
    transform: "translate(61.3562 14.28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColorMobile);
export default __webpack_public_path__ + "static/media/logo_color_mobile.5aa4894148b72ee2b8d59c4b2e92e9dc.svg";
export { ForwardRef as ReactComponent };